import { DatePickerTheme } from 'styled-components';

import { darkTheme, lightTheme, colors } from '@controlrooms/design-tokens';

export const datePickerDarkTheme: DatePickerTheme = {
  chevronColor: colors.content['neutral-2'],
  container: {
    boxShadow: '0px 3px 8px rgba(0, 0, 0, 0.24)',
  },
  selector: {
    bottomBorder: `1px solid ${colors.k[65]}`,
  },
  cell: {
    backgroundColor: colors.content['neutral-2'],
    color: colors.k[0],
    hover: {
      backgroundColor: '#e9e9e9',
    },
    selected: {
      backgroundColor: '#0036cc',
      color: '#ffffff',
    },
  },
};

// TODO: light theming colors
export const datePickerLightTheme: DatePickerTheme = {
  chevronColor: colors.k[0],
  container: {
    boxShadow: '0px 3px 8px rgba(0, 0, 0, 0.24)',
  },
  selector: {
    bottomBorder: `1px solid ${colors.k[65]}`,
  },
  cell: {
    backgroundColor: colors.content['neutral-2'],
    color: colors.k[0],
    hover: {
      backgroundColor: '#e9e9e9',
    },
    selected: {
      backgroundColor: '#0036cc',
      color: '#ffffff',
    },
  },
};

export const datePickerTheme = Object.fromEntries(
  Object.entries({ light: lightTheme, dark: darkTheme }).map(([key, theme]) => [
    key,
    {
      textActive: theme.color.text.core['-primary'],
      textInactive: theme.color.text.core['-tertiary'],
      label: theme.color.text.core['-primary'],
      cell: theme.color.control.input.neutral,
      cellBorder: theme.color.surface[3],
      cellSelected: theme.color.focus[5],
      cellSelectedBorder: theme.color.focus[1],
      header: theme.color.text.core['-tertiary'],
      year: theme.color.text.core['-primary'],
      calendarBG: theme.color.surface[0],
    },
  ]),
);
